import { render, staticRenderFns } from "./FinlayLab.vue?vue&type=template&id=5cbfbf01&scoped=true"
import script from "./FinlayLab.vue?vue&type=script&lang=js"
export * from "./FinlayLab.vue?vue&type=script&lang=js"
import style0 from "./FinlayLab.vue?vue&type=style&index=0&id=5cbfbf01&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbfbf01",
  null
  
)

export default component.exports